module.exports = __webpack_public_path__ + "img/company43.92827c12.png";